<template>
  <div id="HolterAnalysisJudgment">
    <div id="container-center">
      <div class="labelTitle lable">ホルター心電図解析 判定一覧</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber" maxlength="20"/></td>
            <th>機種</th>
            <td><select id="kind" v-model="searchConditions.instrumentKind">
                <option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option>
              </select>
            </td>
            <th>状態</th>
              <td><select v-model="searchConditions.status">
              <option :value="null"></option>
                <option value="2">判定中</option>
                <option value="3">判定済み</option>
                <option value="4">ファイル差替中</option>
              </select></td>
          </tr>
          <tr>
            <th>判定期限</th>
            <td colspan="3"><input type="date" v-model="searchConditions.analysisDeadlineStart"/> ～ <input type="date" v-model="searchConditions.analysisDeadlineEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch" >検索</b-button>
        </div>
      </div>
      <template v-if="hasResult">
        <div class="result-area" v-if="hasResult" >
          <span class="result-count">件数：{{data.length}}件</span>
          <b-table
            id="holterAnalysisResultTable"
            :data="data"
            :paginated="isPaginated"
            per-page="100"
            pagination-position="both"
            default-sort="judgmentDocterAnalysisLimit"
            default-sort-direction="asc"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="80" sortable centered>
                <router-link :to="{name:'HolterAnalysisJudgmentDetail', params:{item:props.row, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="judgmentDocterAnalysisLimit" label="判定期限" width="80" sortable centered >
                {{props.row.judgmentDocterAnalysisLimit }}
              </b-table-column>
              <b-table-column field="returnDeadline" label="返却希望日" width="80" sortable centered>
                {{props.row.returnDeadline }}<span v-if="props.row.urgent" class="urgent" />
              </b-table-column>
              <b-table-column field="instrumentKind" label="機種" width="50" sortable>
                {{props.row.instrumentKind}}
              </b-table-column>
              <b-table-column field="hospital" label="医療機関" width="190" sortable>
                {{props.row.hospital}}
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="100" sortable>
                {{props.row.patientName}}
              </b-table-column>
              <b-table-column v-if="props.row.cvhri!=-1" field="cvhri" label="CVHRI" width="75" sortable centered>
                {{props.row.cvhri}}
              </b-table-column>
              <b-table-column v-if="props.row.cvhri==-1" field="cvhri" label="CVHRI" width="50" sortable centered>
                算出不可
              </b-table-column>
              <b-table-column field="af" label="AF" width="50" sortable centered>
                {{ props.row.af == 1 ? '有' : '無' }}
              </b-table-column>
              <b-table-column
                field="status"
                label="状態"
                width="80"
                centered
                sortable>
                <span
                  :class="getTagClass4PSGApproval(props.row.status)"
                  style="width:100px;">{{ props.row.status }}</span>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </template>
      <div class="button-area" style="margin-top: 10px;">
        <b-button class="backButton is-primary" @click="back" >戻る</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

export default {
  name: "HolterAnalysisJudgment",
  methods: {
    doSearch: function () {
      this.searchConditions.judgmentDocterId = null
      let isSearchParam = false
      const keys = Object.keys(this.searchConditions)
      for (let i = 0; i < keys.length; i++) {
        if (this.searchConditions[keys[i]]) {
          isSearchParam = true
          break
        }
      }

      if (!isSearchParam) {
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage('検索条件が入力されていません。')
        return
      }

      this.searchConditions.judgmentDocterId = this.userInfo.id
      
      if(!this.searchConditions.status) this.searchConditions.status = "5"
      
      this.data = []
      this.hasResult = false
      const excuteApi = this.getHolterAnalysisResultApprovalListPOST
      const successCallBack = this.getHolterAnalysisResultApprovalListPOSTSuccess
      const errorCallBack = this.getHolterAnalysisResultApprovalListPOSTError
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    getHolterAnalysisResultApprovalListPOST: function (client) {
      const obj = JSON.parse(JSON.stringify(this.searchConditions))
      return client.apis.apiCommon.getHolterJudgmentListPOST({
        body: obj
      })
    },
    getHolterAnalysisResultApprovalListPOSTSuccess: function (result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true
      if(this.searchConditions.status == "5") this.searchConditions.status = null
    },
    getHolterAnalysisResultApprovalListPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result)
    },
    back: function() {
      //外部ユーザーホーム
      this.$router.push({ path: "/guest/home" });
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.holterMethod, false);
      this.analysisOptionList = this.getChoiceList(this.choicesType.holterAnalysisOp, false);
      this.analysisMethodList.unshift({})
      this.analysisOptionList.unshift({})
      this.modelList = this.getChoiceList(this.choicesType.holterKind, false);
      this.modelList.unshift({})
      
      // todo テスト効率化、後程消す？
      this.searchConditions.instrumentKind = this.modelList[1].value
    },
  },
  data() {
    const takeOverSearchParams = this.$route.params['searchConditions']
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var doctorName = ""
    var searchConditions = {
      instrumentKind:"",
      status: '2',
    }
    var resultList = []
    var hasResult = false
    var kindStr = this.$route.params["kind"];
    if(this.$route.params["doctorName"]){
      doctorName = this.$route.params["doctorName"]
    }
    if(this.$route.params["searchConditions"]){
      searchConditions = this.$route.params["searchConditions"]
    }
    
    return {
      userInfo,
      choicesType:choicesType,
      hasResult,
      searchConditions,
      kindStr,
      resultList,
      modelList:[],
      analysisMethodList:[],
      analysisOptionList:[],
      doctorName,
      data: null,
      isPaginated: true,
      atLaunchHidden: atLaunchHidden,
      takeOverSearchParams
    };
  },
  filters: {
    getChoiceFilter(value, analysisMethodList){
      var target = analysisMethodList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    }, 
  },
  components: {},
  mounted: function() {
    // 機種マスタ取得
    this.getChoicesList();
    if (this.takeOverSearchParams) {
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.startButton {
  margin-left: 30px;
}
.judgeString-area {
  text-align: left;
  margin-bottom: 10px;
}
.result-area {
  margin-top: 10px;
}
.tableScroll-area {
  max-height: 580px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.innerTable tr,
.innerTable th,
.innerTable td {
  height: 100%;
  border: 1px solid lightslategray;
  text-align: center;
}
.innerTable td {
  width:50px;
}
.judgeSelect {
  font-size: 30px;
}
.comment {
  width: 100%;
  height: 180px;
}
.font-small {
  font-size: 11px;
}
input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/HolterAnalysisJudgment.vue